function AboutMe() {
  const imageSrc = `${process.env.PUBLIC_URL}/images/intro.jpg`;
  const alt = "Kojnok Tünde bemutatkozás"

  return (
    <div className="container my-4 container-wide box-shadow" id="about-me">
        <div className="row flex-md-row-reverse justify-content-center align-items-center py-4 px-5">
            <div className="col-12 col-md-5 col-lg-4">
                <img
                    src={imageSrc}
                    className="d-none d-md-block mx-auto img-fluid rounded-1 box-shadow"
                    alt={alt}
                    width={250} 
                    loading="lazy"
                />
            </div>
            <div className="col-md-7">
                <h1 className="fw-bold text-body-emphasis lh-1 mt-4 mt-md-0 mb-4 quint palegreen">
                    Kojnok Tünde
                </h1>
                <img
                    src={imageSrc}
                    className="d-block d-md-none me-auto my-4 img-fluid rounded-1 box-shadow"
                    width={200}
                    alt={alt}
                    loading="lazy"
                />
                <p className="my-2">
                    Nagyon ki vagyunk téve a <b>testi és lelki</b> ártalmaknak és a
                    legnagyobb igyekezetünkkel sem biztos, hogy kordában tudjuk tartani a
                    megváltozott állapot okozta tüneteket.
                </p>
                <p className="my-2">
                    Segíteni szeretnék azoknak, akik az <b>alternatív</b> kezelés -
                    általam javasolt - formáit kipróbálnák, alkalmaznák{" "}
                    <b>átmeneti vagy tartós</b> időszakra.
                </p>
            </div>
        </div>
    </div>
  );
}

export default AboutMe;
